import {
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PickerDate from "../../../partials/pickerDate";
import PopUpInterface from "../../popUpInterface";
import Module from "./module";
import { styles } from "./style.js";

class ChangePackage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      value: "",
      packageList: [],
      //  startPackage: new Date().getTime(),
      //  endPackage: new Date().getTime(),
      expiredDay: 0,
    };
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.packageList &&
      nextProps.packageList.length &&
      !this.state.packageList.length
    ) {
      let packageList = nextProps.packageList;
      let basicPackage = packageList[0] ? packageList[0].moduleRole : {};
      this.setState({
        packageList: packageList,
        value: packageList[0] ? packageList[0].packageCode : "",
      });
      if (basicPackage)
        this.PopUpInterface.Module.handleShowModule(basicPackage);
    } else if (
      nextProps.packageList &&
      nextProps.packageList.length &&
      Object.keys(this.props.moduleRole).length > 0
    ) {
      let packageList = nextProps.packageList;
      let customPackage = packageList[4] ? packageList[4].moduleRole : {};
      customPackage = Object.assign(customPackage, nextProps.moduleRole);
      packageList[4].moduleRole = customPackage;
      this.setState({
        packageList: packageList,
        value: packageList[0] ? packageList[0].packageCode : "",
      });
    }
  }
  handleClickOpen = () => {
    let basicPackage = this.state.packageList[0]
      ? this.state.packageList[0].moduleRole
      : {};
    this.setState({
      value: this.state.packageList[0]
        ? this.state.packageList[0].packageCode
        : "",
      expiredDay: 0,
    });
    if (basicPackage) this.PopUpInterface.Module.handleShowModule(basicPackage);
    this.PopUpInterface.handleDialogOpen();
  };

  handleClose = () => {
    this.PopUpInterface.handleDialogClose();
  };
  handleChange = (event) => {
    let filter = this.state.packageList.find(
      (packages) => packages.packageCode === event.target.value
    );
    if (filter) {
      this.setState({ value: event.target.value });
      this.PopUpInterface.Module.handleShowModule(filter.moduleRole);
      this.setState({
        expiredDay: filter.days ? moment().add(filter.days, "day") : 0,
      }); // nếu days = 0 là gói basic nên expiredDay là 0
    }
  };
  handleSelectPackage = () => {
    this.props.handleSelectPackage({
      packageCode: this.state.value,
      package: this.PopUpInterface.Module.getModule(),
      expiredDay: this.state.expiredDay,
    });
  };
  handleResetModule = () => {
    this.PopUpInterface.Module.handleShowModule(
      this.PopUpInterface.Module.getInitModule()
    );
  };
  handleChangePickerDate = (value, nameInput) => {
    let state = this.state;
    state[nameInput] = value;
    this.setState(state);
  };
  render() {
    const { classes, t } = this.props;
    const { packageList, expiredDay } = this.state;
    return (
      <PopUpInterface
        handleDialogClose={this.handleClose}
        flagOpen={this.state.open}
        onRef={(dialog) => (this.PopUpInterface = dialog)}
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.DialogTitle}
          onClose={this.handleClose}
        >
          <Typography variant="h4" className={classes.titlePopup}>
            {t("module_select_package")}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent dividers>
          <div className={classes.headerContent}>
            <FormControl
              component="fieldset"
              className={classes.formControlPopup}
            >
              <RadioGroup
                aria-label="gender"
                name="gender1"
                className={classes.group}
                value={this.state.value}
                onChange={this.handleChange}
              >
                {packageList.map((packages) => (
                  <FormControlLabel
                    value={packages.packageCode}
                    control={<Radio />}
                    label={packages.packageName}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <div className={classes.topBarRight}>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                classes={{ containedPrimary: classes.colorButtonViewReport }}
                onClick={this.handleResetModule}
              >
                {t("module_reset")}
              </Button>
              <Button
                disabled={this.state.isSaved ? true : false}
                className={classes.button}
                variant="contained"
                color="secondary"
                onClick={this.handleSelectPackage}
              >
                {t("module_save")}
              </Button>
            </div>
          </div>
          {expiredDay ? (
            <div className={classes.containerPicker}>
              {/* <Typography variant="h6">{t('Apply From')}</Typography> */}
              {/* <PickerDate handleChange={this.handleChangePickerDate} nameInput="startPackage"/>  */}
              <Typography className={classes.titlePicker} variant="h6">
                {t("module_package_is_valid_until_date")}
              </Typography>
              <PickerDate
                handleChange={this.handleChangePickerDate}
                nameInput="expiredDay"
                time={this.state.expiredDay}
              />
            </div>
          ) : (
            ""
          )}
          <Module
            onRef={(id) => (this.PopUpInterface.Module = id)}
            handleStatusButton={this.handleStatusButton}
          />
        </DialogContent>
      </PopUpInterface>
    );
  }
}
ChangePackage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ChangePackage)
  )
);
